import { useCallback, useEffect } from 'react';
import { useGameState } from '@/hooks/useGameState';
import { GameCanvas } from '@/components/GameCanvas';
import { HUD } from '@/components/HUD';
import { StartScreen } from '@/components/StartScreen';
import { trackLooplayView, startLooplayAttempt, trackPlayByType, trackMatch, emitGameEvent } from '@/looplay';
export function HomePage() {
  const { score, bestScore, gameStarted, sessionStartedAt, startGame, incrementScore, stopGame } = useGameState();
  // Track view when page loads
  useEffect(() => {
    trackLooplayView();
  }, []);
  const handleStartGame = useCallback(() => {
    startLooplayAttempt();
    startGame();
  }, [startGame, startLooplayAttempt]);
  const handleStopGame = useCallback(() => {
    // Calculate session duration for tracking
    const sessionDurationSeconds = sessionStartedAt ? Math.floor((Date.now() - sessionStartedAt) / 1000) : 0;
    // Track the play session
    if (sessionDurationSeconds > 0) {
      void trackPlayByType({
        trackingType: 'survival',
        startedAtMs: sessionStartedAt!,
      });
      // Generate a simple match ID
      const matchId = `session-${sessionStartedAt}`;
      void trackMatch(matchId, {
        durationSeconds: sessionDurationSeconds,
        isCompleted: true,
        isWin: false,
      });
      // Emit game ended event
      void emitGameEvent('GAME_ENDED', {
        payload: { score, bestScore, sessionSeconds: sessionDurationSeconds },
      });
    }
    stopGame();
  }, [sessionStartedAt, score, bestScore, stopGame]);
  return (
    <div className="relative w-screen h-[100dvh] overflow-hidden bg-sky-200">
      {!gameStarted ? (
        <StartScreen onStart={handleStartGame} bestScore={bestScore} />
      ) : (
        <>
          <GameCanvas
            isPlaying={gameStarted}
            onScoreChange={incrementScore}
          />
          <HUD
            score={score}
            bestScore={bestScore}
            onStop={handleStopGame}
          />
        </>
      )}
    </div>
  );
}